import { IRouterProps } from "@Interface/Login"
import { AiOutlineTrophy } from "react-icons/ai";
import { IoSettingsOutline } from "react-icons/io5";
import { LuScanLine } from "react-icons/lu";
import { LiaWalletSolid } from "react-icons/lia";
import withRouter from "../../common/withRouter"
import { useAppDispatch, useTypedSelector } from "@redux/store";
import React from "react";
import { operations, selectors } from "@redux/index";
import { shallowEqual } from "react-redux";
import { FiHome } from "react-icons/fi";
import { t } from "@utils/translations";
import { pushToDataLayer } from "@utils/gtm";

const Footer: React.FC<IRouterProps> = ({ router }) => {
  const dispatch = useAppDispatch();

  const { selectedMenu } = useTypedSelector((state) => ({
    loggedInDetails: selectors.loggedInDetails(state),
    selectedMenu: selectors.selectedMenu(state)
  }), shallowEqual);

  const onClickMenu = (menuName: string) => {
    router.navigate(`/${menuName}`)
  }

  const submitDatalayerEvent = (ctaClick: string) => {
    pushToDataLayer({
      'event': 'eventTracker',
      'custom_event_name': 'cta_click',
      'cta_name': ctaClick ?? '',
      'cta_type': 'button',
      'cta_position': 'footer'
    });
  }

  const footerTabClass = 'relative flex h-full flex-1 cursor-pointer flex-col items-center justify-center gap-1 p-[7px_0] text-primary'

  return (
    <>
      <div className="max-w-[500px] fixed bottom-0 w-full rounded-t-xl bg-white pb-[env(safe-area-inset-bottom,0px)] shadow-[0px_-4px_6px_-2px_rgba(0,0,0,0.20),0px_-10px_20px_-4px_rgba(0,0,0,0.06)] z-10">
        <div className="flex h-17.5 w-full items-stretch">
          <span
            className={footerTabClass}
            onClick={() => {
              onClickMenu('home')
              submitDatalayerEvent('home')
            }}
          >
            {selectedMenu === 'home' && (
              <span className="pointer-events-none absolute inset-x-0 bottom-0 h-1.5 bg-(--button-green)" aria-hidden />
            )}
            <FiHome
              className="text-3xl m-auto"
              color={selectedMenu === 'home' ? 'var(--button-green)' : 'gray'}
            />
            <p className={`m-0 p-0 font-bold text-[0.625rem] text-center ${selectedMenu === 'home' ? 'text-(--button-green)' : 'text-gray-500'}`}>
              {t('menu.home')}
            </p>
          </span>

          <span className={footerTabClass}
            onClick={() => {
              onClickMenu('rewards')
              submitDatalayerEvent('rewards')
            }}
          >
            {selectedMenu === 'rewards' && (
              <span className="pointer-events-none absolute inset-x-0 bottom-0 h-1.5 bg-(--button-green)" aria-hidden />
            )}
            <AiOutlineTrophy
              className="text-3xl m-auto text-primary"
              color={selectedMenu === 'rewards' ? 'var(--button-green)' : 'gray'}
            />
            <p className={`m-0 p-0 font-bold text-[0.625rem] text-center ${selectedMenu === 'rewards' ? 'text-(--button-green)' : 'text-gray-500'}`}>
              {t('menu.rewards')}
            </p>
          </span>

          <span
            className={`flex flex-col items-center size-20 py-2.5 px-0.5 gap-1 text-white rounded-full bg-linear-to-b from-[#125F30] to-[#489D2F] -translate-y-5 border-3 border-white box-shadow`}
            onClick={() => {
              onClickMenu('upload-receipt')
              submitDatalayerEvent('upload receipt')
            }}
          >
            <LuScanLine className="text-3xl m-auto" />
            <p className="m-0 p-0 font-bold text-[0.625rem] text-center text-white">{t('menu.upload')}</p>
          </span>

          <span className={footerTabClass}
            onClick={() => {
              submitDatalayerEvent('vouchers')
              router.navigate('/reward-history')
              dispatch(operations.dispatchSelectedMenu('vouchers'))
            }}
          >
            {selectedMenu === 'vouchers' && (
              <span className="pointer-events-none absolute inset-x-0 bottom-0 h-1.5 bg-(--button-green)" aria-hidden />
            )}
            <LiaWalletSolid
              className="text-3xl m-auto text-primary"
              color={selectedMenu === 'vouchers' ? 'var(--button-green)' : 'gray'}
            />
            <p
              className={`m-0 p-0 font-bold text-[0.625rem] text-center ${selectedMenu === 'vouchers' ? 'text-(--button-green)' : 'text-gray-500'
                }`}
            >
              {t('menu.vouchers')}
            </p>
          </span>

          <span
            className={footerTabClass}
            onClick={() => {
              onClickMenu('profile')
              submitDatalayerEvent('profile')
              dispatch(operations.dispatchSelectedMenu('profile'))
            }}
          >
            {selectedMenu === 'profile' && (
              <span className="pointer-events-none absolute inset-x-0 bottom-0 h-1.5 bg-(--button-green)" aria-hidden />
            )}
            <IoSettingsOutline
              className="text-3xl m-auto text-primary"
              color={selectedMenu === 'profile' ? 'var(--button-green)' : 'gray'}
            />
            <p
              className={`m-0 p-0 font-bold text-[0.625rem] text-center ${selectedMenu === 'profile' ? 'text-(--button-green)' : 'text-gray-500'
                }`}
            >
              {t('menu.profile')}
            </p>
          </span>
        </div>
      </div>
    </>
  )
}

export default withRouter(Footer)